import { styled } from "@mui/material";
import { ModalActions } from "@kaltura/ds-react-components";

export const StyledModalActions = styled(ModalActions)(({ theme }) => ({
    justifyContent: "space-between",
}));

export const StyledCheckboxContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));
